import React, { useRef, useState } from 'react';
import cogoToast from 'cogo-toast';
import HotelVoucherTemplate from './HotelVoucherTemplate';
import { exportHotelVoucherPdfFromElement } from './HotelVoucherReport';
import './HotelVoucherPreviewModal.css';

const HotelVoucherPreviewModal = ({ show, data, onClose }) => {
    const voucherRef = useRef(null);
    const [isPdfGenerating, setIsPdfGenerating] = useState(false);

    const handlePrintPdf = async () => {
        const element = voucherRef.current?.querySelector('#hotel-voucher-print-root');
        if (!element || !data) return;

        setIsPdfGenerating(true);
        try {
            await exportHotelVoucherPdfFromElement(element, data);
        } catch {
            cogoToast.error('Failed to generate PDF', { position: 'bottom-center' });
        } finally {
            setIsPdfGenerating(false);
        }
    };

    if (!show || !data) return null;

    return (
        <div className="modal show-modal modalWrapper hotel-voucher-modal">
            <div className="modal-dialog hotel-voucher-modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h3>Hotel Voucher</h3>
                        <i
                            className="fa-regular fa-circle-xmark text-danger"
                            onClick={onClose}
                            role="button"
                            aria-label="Close"
                        />
                    </div>

                    <div className="modal-body hotel-voucher-modal-body" ref={voucherRef}>
                        <div className="hotel-voucher-preview-frame">
                            <HotelVoucherTemplate data={data} />
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={handlePrintPdf}
                            disabled={isPdfGenerating}
                        >
                            {isPdfGenerating ? 'Generating...' : 'Print as PDF'}
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={onClose}
                            disabled={isPdfGenerating}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HotelVoucherPreviewModal;
